const data = {
  "chat": {
    "buttonLabel": "Ga terug naar de live chat",
    "inputLabel": "Stuur een bericht",
    "inputPlaceholder": "Typ hier je bericht...",
    "inputIcon": "Stuur",
    "you": "Jij",
    "disclaimer": "Onze digitale assistent helpt je, maar kan zich net als een mens soms vergissen.",
    "closeChat": "Chat sluiten",
    "login": "Inloggen",
    "denyLogin": "Doorgaan zonder in te loggen",
    "loginSuccess": "Je bent succesvol ingelogd."
  },
  "chatbotEntrance": {
    "title": "Wil je contact opnemen?",
    "title_variation_d_e": "Heb je een vraag?",
    "description": "Stel je vraag aan onze digitale assistent en hij koppelt je aan de juiste specialist.",
    "description_variation_d_e": "Stel 'm aan onze digitale assistent en hij koppelt je aan de juiste specialist.",
    "makeContact": "Neem contact met ons op",
    "makeContact_variation_c_e": "Start gesprek",
    "inputPlaceholder": "Typ je vraag of bericht"
  }
};

export default data;